import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import { Link } from 'react-router-dom';


const TermsPage = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>Terms and Conditions</h1>
                                </div>
                            </div>
                        </div>
                </section>
                <section className="terms_condition_section section_space pt-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                
                                <p><strong>Effective Date:</strong> 1 June 2025</p>
                                <p>
                                    Welcome to <strong>Ease My Hotel</strong> (“we,” “our,” or “us”). These Terms and Conditions (“Terms”) govern your use of our hotel management software and related services (collectively, the “Service”) offered via our website and software platform.
                                </p>
                                <p>
                                    By accessing, installing, or using our Service, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not use our Service.
                                </p>

                                <h2>1. Definitions</h2>
                                <ul>
                                    <li><strong>“Client,” “you,” or “your”</strong> means the individual or entity that purchases, subscribes to, or uses our Service.</li>
                                    <li><strong>“Service”</strong> means the Ease My Hotel software and all features, functionality, and support services provided.</li>
                                    <li><strong>“User”</strong> means any individual authorized by the Client to access and use the Service.</li>
                                </ul>

                                <h2>2. Eligibility</h2>
                                <p>You must be at least 18 years old and capable of entering into a binding legal agreement to use the Service.</p>

                                <h2>3. License Grant</h2>
                                <p>We grant you a limited, non-exclusive, non-transferable, and revocable license to use the Service solely for your business operations in accordance with these Terms.</p>

                                <h2>4. Account Registration</h2>
                                <p>You are responsible for providing accurate account details and maintaining confidentiality of your credentials.</p>

                                <h2>5. Subscription and Payment</h2>
                                <ul>
                                    <li><strong>Subscription Plans:</strong> Access is subscription-based with varying levels of features.</li>
                                    <li><strong>Billing:</strong> Fees are billed in advance and are non-refundable unless stated otherwise.</li>
                                    <li><strong>Late Payments:</strong> May result in suspended or terminated access.</li>
                                    <li><strong>Taxes:</strong> You are responsible for all applicable taxes.</li>
                                </ul>

                                <h2>6. Use Restrictions</h2>
                                <p>You agree not to misuse the Service or violate any laws, intellectual property, or disrupt its functionality.</p>

                                <h2>7. Data Ownership and Privacy</h2>
                                <ul>
                                    <li>You retain ownership of the data you input.</li>
                                    <li>We may use anonymized data for improving the Service.</li>
                                    <li>Our use of your data is governed by our <Link to="/privacy-policy">Privacy Policy</Link>.</li>
                                </ul>

                                <h2>8. Service Availability</h2>
                                <p>We strive for uninterrupted access but do not guarantee 100% uptime.</p>

                                <h2>9. Support and Maintenance</h2>
                                <p>Support is included in your subscription. Maintenance may include scheduled downtimes with prior notice.</p>

                                <h2>10. Intellectual Property</h2>
                                <p>All rights in the Service are owned by Ease My Hotel. You receive no rights beyond the license provided herein.</p>

                                <h2>11. Termination</h2>
                                <p>We may suspend or terminate your access for breaches. Upon termination, access ends and data will be retained for 30 days.</p>

                                <h2>12. Limitation of Liability</h2>
                                <p>We are not liable for indirect damages or loss of profits. Our total liability is limited to what you paid in the prior 12 months.</p>

                                <h2>13. Indemnification</h2>
                                <p>You agree to indemnify us against claims arising from your use of the Service or violation of these Terms.</p>

                                <h2>14. Modifications</h2>
                                <p>We may update these Terms at any time. Continued use of the Service constitutes your acceptance of the changes.</p>

                                <h2>15. Governing Law</h2>
                                <p>These Terms are governed by the laws of India and subject to the jurisdiction of courts in [Insert Jurisdiction, e.g., Kanpur, Uttar Pradesh].</p>

                                <h2>16. Contact Us</h2>
                                <p>If you have any questions, contact us at:</p>
                                <p>
                                    <strong>Ease My Hotel</strong><br />
                                    Email: <a href="mailto:support@easemyhotel.com">support@easemyhotel.com</a><br />
                                    Phone: +91-8299406767<br />
                                    Address: 117/Q/457/10A Indrapuri Sharda Nagar Kanpur Pincode 208025
                                </p>


                            </div>
                        </div>
                    </div>
                </section>
               
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default TermsPage;